import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';

import React, { useContext } from 'react';

import { CallCenterListDTO } from '_lib/api/apiTypes.shim';
import { Avatar } from '_lib/components/Avatar/Avatar';
import { DialogContent } from '_lib/components/DialogContent/DialogContent';
import { List } from '_lib/components/List/List';
import { ListItemAvatar } from '_lib/components/ListItemAvatar/ListItemAvatar';
import { ListItemButton } from '_lib/components/ListItemButton/ListItemButton';
import { ListItemText } from '_lib/components/ListItemText/ListItemText';
import { AuthContext } from '_lib/featureComponents/auth/authContext';
import { DialogWrapper } from '_lib/featureComponents/DialogWrapper/DialogWrapper';
import { AsyncDialogProps, useAsyncDialog } from '_lib/hooks/useAsyncDialog';
import { formatAddressOneLine } from '_lib/utils/helpers';

type SelectCallCenterDialogProps = Omit<AsyncDialogProps, 'dismissable'> & {
  callCenters: CallCenterListDTO[];
};

const SelectCallCenterDialog = (props: SelectCallCenterDialogProps) => {
  const { onClose, titleText, callCenters, ...dialogProps } = props;

  const { callCenterCacheResource } = useContext(AuthContext);

  return (
    <DialogWrapper dismissable={false} onClose={onClose} titleText={titleText || 'SELECT CALL CENTER'} {...dialogProps}>
      <DialogContent>
        <List sx={{ padding: 0 }}>
          {callCenters.map((callCenter) => (
            <ListItemButton
              key={callCenter.id}
              divider={callCenters.length !== 1}
              onClick={async () => {
                await callCenterCacheResource.set(callCenter.id).catch(() => {});
                onClose();
              }}>
              <ListItemAvatar>
                <Avatar>
                  <HeadsetMicIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={callCenter.name}
                secondary={formatAddressOneLine(callCenter, { includeCountry: true })}
              />
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
    </DialogWrapper>
  );
};

export const useSelectCallCenterDialog = () => useAsyncDialog(SelectCallCenterDialog);
